<footer *ngIf="!showFooter" [ngClass]="{'fixed-box-height': addFixedBoxheight}" class="bg-light-2 padding-top-bottom-20 txt-center">
  <div class="content-wrap">
    <ng-container *ngIf="sys === 'wt'">
      <ng-container *ngIf="('lang' | translate) === 'en'">
        <img
          class="footer-secure-payment margin-bottom-20"
          src="https://d3tmfelegj51yl.cloudfront.net/global-json/secure-payment/wt/en/secure-payment.png"
          alt=""
        />
      </ng-container>
      <ng-container *ngIf="('lang' | translate) === 'es' || ('lang' | translate) === 'pt'">
        <img
          class="footer-secure-payment margin-bottom-20"
          src="https://d3tmfelegj51yl.cloudfront.net/global-json/secure-payment/wt/es/secure-payment.png"
          alt=""
        />
      </ng-container>
    </ng-container>
    <ng-container *ngIf="sys === 'ltk'">
      <ng-container *ngIf="('lang' | translate) === 'en'">
        <img
          class="footer-secure-payment margin-bottom-20"
          src="https://d3tmfelegj51yl.cloudfront.net/global-json/secure-payment/ltk/en/secure-payment.png"
          alt=""
        />
      </ng-container>
      <ng-container *ngIf="('lang' | translate) === 'es' || ('lang' | translate) === 'pt'">
        <img
          class="footer-secure-payment margin-bottom-20"
          src="https://d3tmfelegj51yl.cloudfront.net/global-json/secure-payment/ltk/en/secure-payment.png"
          alt=""
        />
      </ng-container>
    </ng-container>
    <app-copy></app-copy>
  </div>
</footer>
